module.exports = __webpack_public_path__ + "img/type3.bc762d5d.png";